import Icon from '../components/Icon.vue'

Icon.register({
  'globe-africa': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM408 223.5V230.4C408 236.3 404.7 241.7 399.4 244.3L384 252A15.5-15.5 0 0 0 368.5 251L350.3 238.9A15.5-15.5 0 0 1 336.8 237.1L334.2 237.9C324.5 241.2 320.5 252.7 326.2 261.3L339.4 281.1C342.3 285.4 347.1 288 352.3 288H360.5C369.1 288 376 294.9 376 303.5V314.9C376 318.2 374.9 321.5 372.9 324.1L354.2 349.1C352.7 351 351.8 353.2 351.3 355.6L347 378.4C346.4 381.7 344.7 384.7 342.3 386.9A159.6-159.6 0 0 1 317.3 416.1L304.2 435.7A27.8-27.8 0 0 0 281.2 448C270.6 448 261 442.1 256.3 432.7A78.9-78.9 0 0 0 248 397.4V367.5C248 358.9 241.1 352 232.5 352H206.6C192.1 352 178.2 346.2 168 336A54.7-54.7 0 0 0 152 297.4V283.3C152 266.1 160.1 249.9 173.8 239.6L201.4 218.9A54.7-54.7 0 0 0 234.2 208H235.1C243.6 208 251.9 210 259.5 213.8L274.2 221.1C277.9 223 282.2 223.3 286.1 222L333.4 206.2C339.7 204.1 344 198.2 344 191.5 344 182.9 337 176 328.5 176H318.4C314.3 176 310.3 174.4 307.4 171.4L300.5 164.5A15.5-15.5 0 0 1 289.6 160H199.5C190.9 160 184 153.1 184 144.5V140.1C184 133 188.8 126.8 195.7 125.1L210.2 121.4C213.9 120.5 217.2 118.2 219.3 115L227.4 102.9C230.3 98.6 235.1 96 240.3 96H264.5C273.1 96 280 89.1 280 80.5V58.8C359.2 71.6 422.9 131 441.9 208H423.5C414.9 208 408 214.9 408 223.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/globe-africa.js
// module id = kQtu
// module chunks = 144